import { MDBCol, MDBRow, MDBScrollspy, MDBScrollspyLink } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from "react-i18next";
import { UpdateFreshdeskProfile, getMisc } from '../../../apiclients/streamsapi_bridge';
import SaveChanges from '../../topviews/saveCancel';



function APISettings({
    profileInfo,
    setIsloading,
    setReRender,
    setSuccessMessage,
    setEdited
}) {

    const { t, i18n } = useTranslation();

    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const containerRef = useRef(null);
    const [eventList, setEventList] = useState({});


    const { register, formState, getValues, handleSubmit, setError, clearErrors, reset, watch,formState: { dirtyFields, errors }} = useForm({
        defaultValues: {
            domain: "",
            api_key: "",
            profile_name: "",
            pstn_acd_call_accepted: 1,
            pstn_inbound_call_accepted: 1
        }
    });


    useEffect(() => {
        if (Object.keys(profileInfo ?? {}).length > 0) {
            reset({
                profile_name: profileInfo?.profile_name,
                domain: profileInfo?.domain,
                api_key: profileInfo?.api_key,
                pstn_acd_call_accepted: profileInfo?.pstn_acd_call_accepted,
                pstn_inbound_call_accepted: profileInfo?.pstn_inbound_call_accepted,

            })
        }
    }, [profileInfo])


    async function fetchProfileMiscData() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["freshdesk_info"] }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
        }
        const eventDtls = tdata?.misc?.freshdesk_info?.event_details ?? {};

        setEventList(eventDtls);
    }

    useEffect(() => {
        fetchProfileMiscData();
    }, []);


    const isdirtyFields = Object.keys(dirtyFields).length === 0 ? false : true;

    useEffect(() => {
        setEdited(isdirtyFields);

    }, [isdirtyFields])

    console.log(`isdirtyFields value is ::: ${isdirtyFields}`);

    const onsubmit = async (data) => {
        const modifiedData = {};
        console.log(`dirtyFields value is ::: ${JSON.stringify(dirtyFields)}`);
        for (const field of Object.keys(dirtyFields)) {
            // Check if the field is dirty and exists in the data object
            if (dirtyFields[field] && data.hasOwnProperty(field)) {
                modifiedData[field] = data[field];
            }
        }
        if (modifiedData) {
            modifiedData.reqid = 127;
            modifiedData.siteid = JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid;
            modifiedData.profileid = profileInfo.profileid;

            console.log("JSON Update Profile Settings:: " + JSON.stringify(modifiedData));
            setIsloading(true);
            let saverep = await UpdateFreshdeskProfile(modifiedData);
            console.log(`reponse of Update Profile Settings: :::: ${JSON.stringify(saverep)}`);
            let saverepeMsg = await saverep.json();
            console.log(`reponse of Update Profile Settings: after:::: ${JSON.stringify(saverepeMsg)}`);
            setTimeout(() => {
                setIsloading(false);
            }, 2000);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                setReRender(true);
                setSuccessMessage(saverepeMsg.message);
            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {
                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();

                        }
                    });
                }

            }
        }
    }
    function closeSave(e) {
        reset();
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll('.nav-link');
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest('.sticky-top');
            if (stickyParent && lastLink.classList.contains('active')) {
                lastLink.classList.remove('active');
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest('.sticky-top');
                    if (parent) {
                        firstLink.classList.add('active');
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);


    return (
        <div>
            <MDBRow>
                <MDBCol
                    size="2"
                    md="2"
                    lg="2"
                    sm="12"
                    className="col-sm-100 pr-0 leftTabs leftTabs__fix"
                >

                    <MDBScrollspy container={containerRef} offset={100}>
                        <MDBScrollspyLink targetRef={section1}>{t("api")}</MDBScrollspyLink>
                        <MDBScrollspyLink targetRef={section2}>Freshdesk Domain And API Key</MDBScrollspyLink>
                        <MDBScrollspyLink targetRef={section3}>Events for Pop-up</MDBScrollspyLink>
                    </MDBScrollspy>

                </MDBCol>

                <MDBCol
                    size="12"
                    md="10"
                    sm="12"
                    pr-0
                    className="col-sm-100 pr-0 leftTabContent h-90 overflow-auto"
                >
                    <form>
                        <div id='element' ref={containerRef} className='scrollspy-example'>
                            <section ref={section1} id='section-1'>
                                <div
                                    className="general-settings"
                                    id="Addons"
                                > {t("api")}
                                </div>

                                <div className="ps-0">
                                    <div className="add-numbermain">
                                        <div className="tel-numbers">
                                            API Profile Name
                                        </div>
                                        <div className="phoneselect w-30">
                                            <input className='form-control'
                                                {...register('profile_name', {
                                                    required: "API Profile Name is required",
                                                })}
                                            />
                                            {errors.profile_name && (
                                                <p className="text-danger">{errors.profile_name.message}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="routing-border mt-2"></div>
                            <section ref={section2} id='section-2'>
                                <div
                                    className="general-settings"
                                    id="CallingandSMS"
                                > Freshdesk Domain and API Key
                                </div>
                                <div className="ps-0">

                                    <div className="add-numbermain">
                                        <div className="tel-numbers">
                                            Domain
                                        </div>
                                        <div className="phoneselect d-flex flex-row align-items-center w-30">
                                            <span>https:// </span>
                                            <input className='form-control w-70' placeholder='Freshdesk'
                                                {...register('domain', {
                                                    required: "Domain is required",
                                                })}
                                            />
                                            <span>.freshdesk.com </span>
                                            {errors.domain && (
                                                <p className="text-danger">{errors.domain.message}</p>
                                            )}
                                        </div>
                                    </div>


                                    <div className="add-numbermain">
                                        <div className="tel-numbers">
                                            API Key
                                        </div>
                                        <div className="phoneselect d-flex flex-row w-30">
                                            <input className='form-control w-100' placeholder='API Key'
                                                {...register('api_key', {
                                                    required: "API Key is required",
                                                })}
                                            />
                                            {errors.api_key && (
                                                <p className="text-danger">{errors.api_key.message}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </section>
                            <div className="routing-border mt-2"></div>
                            <section ref={section3} id='section-3'>

                                <div className="general-settings">
                                    {t("Events for Pop-up")}
                                </div>

                                <div className="add-numbermain">
                                    <div className="tel-numbers">
                                        PSTN Inbound Call Accepted
                                    </div>
                                    <div className="phoneselect w-30">
                                        <select
                                            className="form-control form-select selectname"
                                            name="San Jose"

                                            {...register("pstn_inbound_call_accepted", {
                                                setValueAs: (value) => Number(value),
                                                shouldDirty: true,
                                            })}

                                        >

                                            {Object.entries(eventList).map(([key, value]) => (
                                                <option key={key} value={parseInt(key)}>
                                                    {value}
                                                </option>
                                            ))}

                                        </select>
                                    </div>
                                </div>
                                <div className="add-numbermain">
                                    <div className="tel-numbers">
                                        PSTN ACD Call Accepted
                                    </div>
                                    <div className="phoneselect flex-column-sm w-30">
                                        <select
                                            className="form-control form-select selectname"
                                            name="San Jose"

                                            {...register("pstn_acd_call_accepted", {
                                                setValueAs: (value) => Number(value),
                                                shouldDirty: true,
                                            })}

                                        >

                                            {Object.entries(eventList).map(([key, value]) => (
                                                <option key={key} value={parseInt(key)}>
                                                    {value}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </section>
                        </div>
                        {isdirtyFields && (
                            <SaveChanges
                                onClose={closeSave}
                                isdirtyFields={isdirtyFields}
                                onSave={(e) => {
                                    e.preventDefault();
                                    handleSubmit(onsubmit)();
                                }}
                            />
                        )}
                    </form>
                </MDBCol>
            </MDBRow>
        </div>
    )
}

export default APISettings;
